import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=6047b3ce&scoped=true&"
import script from "./Container.vue?vue&type=script&lang=js&"
export * from "./Container.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Container.vue?vue&type=style&index=0&id=6047b3ce&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6047b3ce",
  "6fda5928"
  
)

export default component.exports